<template>
  <div class="mt-4 fon" >
    <b-row class="textSize">
      <b-col>
        <b-card style="height: 400px; border-radius: 10px; max-height: 350px;  overflow-y: scroll;">
          <b-row>
            <b-col cols="1"></b-col>
            <b-col align="left" style="font-weight: 500"><p>Tratamientos programados del paciente</p></b-col>
            <b-col cols="2">OD</b-col>
          </b-row>
          <b-row v-for="(trt, index) of listaTratamientos" :key="index">
            <b-col cols="1">
              <b-form-checkbox
                  v-model="trt.selected"
                  name="trtSeleccionado"
                  :value="true"
                  @input="seleccionarTrt(trt)"
                  :disabled="tratamientoSeleccionado  && tratamientoSeleccionado.nombreTratamiento !== trt.nombreTratamiento || deshabilitado"
              >
              </b-form-checkbox>
            </b-col>
            <b-col align="left">
              {{trt.nombreTratamiento}} {{trt.numeroSesion}}/{{trt.noMaxSesion}}
            </b-col>
            <b-col cols="2">
              {{trt.numeroDiente}}
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col v-if="odSeleccionados.length > 0">
        <b-row>
          <p>Tratamiento seleccionado:</p>
        </b-row>
        <div style="max-height: 300px; overflow-y: scroll;">
          <b-card  v-for="(od,indexOd) in odSeleccionados" :key="indexOd" style="border-color: #A2DAE2; margin-top: 10px;height: 40px; " align="left">
            <span style="color: #39B2C5;display: flex;margin-top: -8px"><em class="tratamiento_outline" style="width: 1.4em;"></em>{{od.nombreTratamiento}} {{od.numeroSesion}}/{{od.noMaxSesion}} (OD {{od.numeroDiente}})</span>
          </b-card>
        </div>
      </b-col>
      <b-col v-else>
        <div class="mt-5">
          <p >Debes seleccionar al menos un tratamiento</p>
        </div>
      </b-col>
    </b-row>

    <div class="text-center textSize mt-2 ">
      <p style="color: darkorange">Sólo es posible seleccionar un tratamiento, distintos od´s</p>

      <b-button variant="outline-primary" pill size="sm"
                @click="siguiente()"
                :disabled="odSeleccionados.length === 0 || deshabilitado"
      >
        <span>Siguiente</span>
      </b-button>
    </div>
    <b-row>
      <b-col align="left"></b-col>
    </b-row>
    <b-row>
      <b-col></b-col>
      <b-col></b-col>
    </b-row>
  </div>
</template>
<script >
export default {
  name: "InformacionTratamiento",
  data: () => ({
    odSeleccionados: [],
    tratamientoSeleccionado: null
  }),
  props:{
    odtMadre: Object,
    listaTratamientos: Array,
    ap: Number,
    index: Number,
    deshabilitado: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.odtMadre !== null && this.odtMadre.infoTratamiento !== null){
      this.listaTratamientos.forEach(trt=>{
        if(this.odtMadre.infoTratamiento.dientes.some(d=>d.idTratamientoProgramado === trt.idTratamientoProgramado)){
          trt.selected = true;
          this.odSeleccionados.push(trt);
        }
      })
    }
  },
  methods: {
    seleccionarTrt(trt){
      console.log("trt",trt);
      if (trt.selected === true){
        this.odSeleccionados.push(trt);
        this.tratamientoSeleccionado = trt
      }else{
        this.odSeleccionados.splice(this.odSeleccionados.indexOf(trt), 1);
       this.odSeleccionados.length === 0 ? this.tratamientoSeleccionado = null : this.tratamientoSeleccionado = trt;
      }
    },
    siguiente(){
      let datos = {
        idTratamiento: null,
        aplicaRestauraciones: false,
        nombreTratamiento: null,
        dientes: [],
        idEmpleado: null,
        puedeFlujoDigital: false,
        idTipoFlujoFisico: null,
      };
      this.odSeleccionados.forEach((trt)=>{
        let dientes = {
          idDiente: trt.idDiente,
          numeroDiente: trt.numeroDiente,
          idTratamientoProgramado: trt.idTratamientoProgramado,
          aplicaEnTodosTercios: true,
          idColorimetroColor: null,
          tercioIncisalOclusal: null,
          tercioMedio: null,
          tercioCervical: null
        }

        datos.idTratamiento = trt.idTratamiento;
        datos.aplicaRestauraciones = trt.aplicaRestauraciones;
        datos.nombreTratamiento = trt.nombreTratamiento;
        datos.dientes.push(dientes);
        datos.idEmpleado = trt.idEmpleado;
        datos.idPaciente = this.$route.params.idPaciente;
        datos.puedeFlujoDigital = trt.flujoDigital
        datos.idTipoFlujoFisico = trt.idTipoFlujoFisico;
      })
      this.$emit('siguiente', datos, 0);
    },

    reset(){
      this.odSeleccionados = [];
      this.tratamientoSeleccionado = null;
      this.listaTratamientos.forEach(trt => {
        trt.selected = false; // Cambia a false cada checkbox
      });
    }
  }
}
</script>
<style scoped>
.textSize {
  font-size: 0.8em;
}
</style>
